const { addFilter } = wp.hooks;

addFilter(
  "blocks.registerBlockType",
  "ubc-group-full-width/group-block-attribute",
  groupBlockAttribute
);

function groupBlockAttribute(settings, name) {
  if ( 'core/group' === name ) {
    settings = {
      ...settings,
      supports: {
        ...settings.supports,
        align: false,
      },
      attributes: {
        ...settings.attributes,
        blockSize: {
          type: "string",
          default: "default"
        },
      }
    };
  }

  return settings;
}
